import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetHealthSpecialtyAuthorizationParams,
	GetHealthSpecialtyAuthorization,
	GetHealthSpecialtyAuthorizationModel,
} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemoteGetHealthSpecialtyAuthorization implements GetHealthSpecialtyAuthorization {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthSpecialtyAuthorizationModel>,
	) {}

	async get(
		params: GetHealthSpecialtyAuthorizationParams,
	): Promise<GetHealthSpecialtyAuthorizationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
